import { sendRequest } from "@/api/clients/axios";

export type DriverAutocompleteItem = {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
};

const DEFAULT_LIMIT = 10;

export async function getDriversAutocomplete(q: string, limit = DEFAULT_LIMIT) {
  const res = await sendRequest<undefined, DriverAutocompleteItem[]>(
    "get",
    "drivers/autocomplete",
    undefined,
    {
      params: { q: q.trim(), limit },
    }
  );
  if (res.status !== 200) {
    return [];
  }
  return res.data ?? [];
}
